/* CarOptions Smart Vehicle Finder
 * Single-input search across the full /products.json catalog.
 * Index: /assets/co-search-index.json (built from products.json + manual backfill).
 * Spec: CarOptions-Searcher-Audit-And-Fix.docx
 */
(function () {
  'use strict';
  if (window.__coFinderInit) return;
  window.__coFinderInit = true;

  var INDEX_URL = window.coFinderIndexUrl || '/assets/co-search-index.json';
  var indexPromise = null;

  // Locale-aware URL prefix — preserves /it/, /fr/, etc. so navigation
  // doesn't drop the visitor back to the default locale.
  // 1) Prefer Shopify's own routes.root (set by liquid via routes object) when present.
  // 2) Otherwise sniff the current URL: if it starts with /xx/ where xx is two
  //    letters or xx-yy, treat it as the locale root.
  function localeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    if (root && root !== '/') {
      return root.replace(/\/$/, '');
    }
    var m = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
    return m ? m[1] : '';
  }
  function withLocale(path) {
    var prefix = localeRoot();
    if (!prefix) return path;
    if (path.indexOf(prefix + '/') === 0) return path; // already prefixed
    return prefix + path;
  }

  // i18n — per-locale string tables. Active locale comes from window.CO_LOCALE
  // (set by layout/theme.liquid for non-English visitors). Falls back to en.
  // Adding a new locale: add a new entry to LOCALE_STRINGS with the same keys.
  var LOCALE_STRINGS = {
  "en": {
    "your_car": "your car",
    "fits_aria": "100% fit",
    "fits_label": "Fits",
    "fit_msg": "Apple CarPlay &amp; Android Auto is <b>100% compatible</b> with your <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Showing results for <b>{to}</b> — searched for \"{from}\"",
    "unsupported_h": "We don't carry {brand} (yet)",
    "unsupported_p": "If you've already confirmed your car has factory CarPlay support, our team can double-check whether one of our boxes will work.",
    "unsupported_btn": "Ask about my car →",
    "grouped_head": "{brand} {model} — pick a year range",
    "generations_head": "{brand} {model} — pick your year range",
    "no_match_h": "No matches",
    "no_match_p": "Try just the brand and year, or contact us if you can't find your car.",
    "no_match_btn": "Ask about my car →",
    "fit_badge": "Fits your {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox for {brand}",
    "fit_info_detected": "Auto-detected for your <b>{system}</b> system.",
    "fit_info_default": "Wireless Apple CarPlay + Android Auto for your factory infotainment.",
    "fit_view_btn": "View product →",
    "fit_change": "Not your car? Change vehicle",
    "yr_present": "present"
  },
  "it": {
    "your_car": "la tua auto",
    "fits_aria": "compatibilità 100%",
    "fits_label": "Compatibile",
    "fit_msg": "Apple CarPlay e Android Auto sono <b>100% compatibili</b> con la tua <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Mostro risultati per <b>{to}</b> — hai cercato \"{from}\"",
    "unsupported_h": "Non offriamo ancora {brand}",
    "unsupported_p": "Se hai già confermato che la tua auto supporta CarPlay di serie, il nostro team può verificare se una delle nostre soluzioni è compatibile.",
    "unsupported_btn": "Chiedi informazioni sulla mia auto →",
    "grouped_head": "{brand} {model} — scegli un intervallo di anni",
    "generations_head": "{brand} {model} — scegli il tuo intervallo di anni",
    "no_match_h": "Nessun risultato",
    "no_match_p": "Prova solo con la marca e l'anno, oppure contattaci se non trovi la tua auto.",
    "no_match_btn": "Chiedi informazioni sulla mia auto →",
    "fit_badge": "Compatibile con la tua {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox per {brand}",
    "fit_info_detected": "Rilevato automaticamente per il tuo sistema <b>{system}</b>.",
    "fit_info_default": "Apple CarPlay e Android Auto wireless per il tuo infotainment di fabbrica.",
    "fit_view_btn": "Vedi prodotto →",
    "fit_change": "Non è la tua auto? Cambia veicolo",
    "yr_present": "oggi"
  },
  "es": {
    "your_car": "tu coche",
    "fits_aria": "compatibilidad 100%",
    "fits_label": "Compatible",
    "fit_msg": "Apple CarPlay y Android Auto son <b>100% compatibles</b> con tu <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Mostrando resultados para <b>{to}</b> — buscaste \"{from}\"",
    "unsupported_h": "Aún no ofrecemos {brand}",
    "unsupported_p": "Si ya has confirmado que tu coche tiene soporte CarPlay de fábrica, nuestro equipo puede comprobar si alguna de nuestras soluciones es compatible.",
    "unsupported_btn": "Pregunta por mi coche →",
    "grouped_head": "{brand} {model} — elige un rango de años",
    "generations_head": "{brand} {model} — elige tu rango de años",
    "no_match_h": "Sin resultados",
    "no_match_p": "Prueba solo con la marca y el año, o contáctanos si no encuentras tu coche.",
    "no_match_btn": "Pregunta por mi coche →",
    "fit_badge": "Compatible con tu {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox para {brand}",
    "fit_info_detected": "Detectado automáticamente para tu sistema <b>{system}</b>.",
    "fit_info_default": "Apple CarPlay y Android Auto inalámbricos para tu infotainment de fábrica.",
    "fit_view_btn": "Ver producto →",
    "fit_change": "¿No es tu coche? Cambiar vehículo",
    "yr_present": "presente"
  },
  "fr": {
    "your_car": "votre voiture",
    "fits_aria": "compatibilité 100%",
    "fits_label": "Compatible",
    "fit_msg": "Apple CarPlay et Android Auto sont <b>100% compatibles</b> avec votre <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Résultats pour <b>{to}</b> — recherche : \"{from}\"",
    "unsupported_h": "Nous ne proposons pas encore {brand}",
    "unsupported_p": "Si vous avez déjà confirmé que votre voiture est compatible CarPlay d'origine, notre équipe peut vérifier si l'une de nos solutions fonctionne.",
    "unsupported_btn": "Posez une question sur ma voiture →",
    "grouped_head": "{brand} {model} — choisissez une plage d'années",
    "generations_head": "{brand} {model} — choisissez votre plage d'années",
    "no_match_h": "Aucun résultat",
    "no_match_p": "Essayez juste la marque et l'année, ou contactez-nous si vous ne trouvez pas votre voiture.",
    "no_match_btn": "Posez une question sur ma voiture →",
    "fit_badge": "Compatible avec votre {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox pour {brand}",
    "fit_info_detected": "Détecté automatiquement pour votre système <b>{system}</b>.",
    "fit_info_default": "Apple CarPlay et Android Auto sans fil pour votre système d'origine.",
    "fit_view_btn": "Voir le produit →",
    "fit_change": "Ce n'est pas votre voiture ? Changer de véhicule",
    "yr_present": "présent"
  },
  "de": {
    "your_car": "Ihrem Auto",
    "fits_aria": "100% Kompatibilität",
    "fits_label": "Kompatibel",
    "fit_msg": "Apple CarPlay und Android Auto sind <b>100% kompatibel</b> mit Ihrem <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Ergebnisse für <b>{to}</b> — gesucht: \"{from}\"",
    "unsupported_h": "Wir bieten {brand} noch nicht an",
    "unsupported_p": "Wenn Sie bereits bestätigt haben, dass Ihr Auto werkseitig CarPlay-kompatibel ist, kann unser Team prüfen, ob eine unserer Lösungen funktioniert.",
    "unsupported_btn": "Frage zu meinem Auto stellen →",
    "grouped_head": "{brand} {model} — wählen Sie einen Jahrgangsbereich",
    "generations_head": "{brand} {model} — wählen Sie Ihren Jahrgangsbereich",
    "no_match_h": "Keine Übereinstimmungen",
    "no_match_p": "Versuchen Sie es nur mit Marke und Jahr, oder kontaktieren Sie uns, wenn Sie Ihr Auto nicht finden können.",
    "no_match_btn": "Frage zu meinem Auto stellen →",
    "fit_badge": "Kompatibel mit Ihrem {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox für {brand}",
    "fit_info_detected": "Automatisch erkannt für Ihr <b>{system}</b>-System.",
    "fit_info_default": "Drahtloses Apple CarPlay und Android Auto für Ihr Werks-Infotainment.",
    "fit_view_btn": "Produkt ansehen →",
    "fit_change": "Nicht Ihr Auto? Fahrzeug wechseln",
    "yr_present": "heute"
  },
  "pl": {
    "your_car": "Twój samochód",
    "fits_aria": "100% dopasowania",
    "fits_label": "Pasuje",
    "fit_msg": "Apple CarPlay &amp; Android Auto są <b>w 100% kompatybilne</b> z Twoim <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Wyświetlanie wyników dla <b>{to}</b> — wyszukiwano \"{from}\"",
    "unsupported_h": "Nie mamy (jeszcze) {brand} w ofercie",
    "unsupported_p": "Jeśli potwierdziłeś już, że Twój samochód ma fabryczną obsługę CarPlay, nasz zespół może dodatkowo sprawdzić, czy jeden z naszych modułów będzie działał.",
    "unsupported_btn": "Zapytaj o mój samochód →",
    "grouped_head": "{brand} {model} — wybierz zakres roczników",
    "generations_head": "{brand} {model} — wybierz zakres roczników swojego auta",
    "no_match_h": "Brak dopasowań",
    "no_match_p": "Spróbuj podać tylko markę i rok lub skontaktuj się z nami, jeśli nie możesz znaleźć swojego samochodu.",
    "no_match_btn": "Zapytaj o mój samochód →",
    "fit_badge": "Pasuje do {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox dla {brand}",
    "fit_info_detected": "Wykryto automatycznie dla systemu <b>{system}</b>.",
    "fit_info_default": "Bezprzewodowy Apple CarPlay + Android Auto dla fabrycznego systemu multimedialnego.",
    "fit_view_btn": "Zobacz produkt →",
    "fit_change": "To nie Twój samochód? Zmień pojazd",
    "yr_present": "obecny"
  },
  "sv": {
    "your_car": "din bil",
    "fits_aria": "100 % passform",
    "fits_label": "Passar",
    "fit_msg": "Apple CarPlay &amp; Android Auto är <b>100% kompatibelt</b> med din <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Visar resultat för <b>{to}</b> — sökte efter \"{from}\"",
    "unsupported_h": "Vi har inte {brand} (än)",
    "unsupported_p": "Om du redan har bekräftat att bilen har fabriksmonterat stöd för CarPlay kan vårt team dubbelkolla om någon av våra boxar fungerar.",
    "unsupported_btn": "Fråga om min bil →",
    "grouped_head": "{brand} {model} — välj ett årsintervall",
    "generations_head": "{brand} {model} — välj årsintervall",
    "no_match_h": "Inga träffar",
    "no_match_p": "Prova att bara ange bilmärke och årsmodell. Kontakta oss om du ändå inte hittar din bil.",
    "no_match_btn": "Fråga om min bil →",
    "fit_badge": "Passar din {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox för {brand}",
    "fit_info_detected": "Identifieras automatiskt för ditt <b>{system}</b>-system.",
    "fit_info_default": "Trådlös Apple CarPlay + Android Auto för bilens fabriksmonterade infotainmentsystem.",
    "fit_view_btn": "Visa produkt →",
    "fit_change": "Inte din bil? Byt fordon",
    "yr_present": "nuvarande"
  },
  "da": {
    "your_car": "din bil",
    "fits_aria": "100% pasform",
    "fits_label": "Passer",
    "fit_msg": "Apple CarPlay &amp; Android Auto er <b>100% kompatibelt</b> med din <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Viser resultater for <b>{to}</b> — der blev søgt efter \"{from}\"",
    "unsupported_h": "Vi fører ikke {brand} (endnu)",
    "unsupported_p": "Hvis du allerede har bekræftet, at din bil har CarPlay fra fabrikken, kan vores team dobbelttjekke, om en af vores bokse fungerer.",
    "unsupported_btn": "Spørg om min bil →",
    "grouped_head": "{brand} {model} — vælg et årgangsinterval",
    "generations_head": "{brand} {model} — vælg dit årgangsinterval",
    "no_match_h": "Ingen resultater",
    "no_match_p": "Prøv kun med mærke og årgang, eller kontakt os, hvis du ikke kan finde din bil.",
    "no_match_btn": "Spørg om min bil →",
    "fit_badge": "Passer til din {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox til {brand}",
    "fit_info_detected": "Automatisk registreret for dit <b>{system}</b>-system.",
    "fit_info_default": "Trådløs Apple CarPlay + Android Auto til bilens originale infotainmentsystem.",
    "fit_view_btn": "Se produkt →",
    "fit_change": "Ikke din bil? Skift køretøj",
    "yr_present": "nuværende"
  },
  "fi": {
    "your_car": "autosi",
    "fits_aria": "100% yhteensopiva",
    "fits_label": "Sopii",
    "fit_msg": "Apple CarPlay &amp; Android Auto on <b>100% yhteensopiva</b> ajoneuvosi <b class=\"co-fit-card__veh\">{label}</b> kanssa",
    "didyoumean": "Näytetään tulokset haulle <b>{to}</b> — alkuperäinen haku \"{from}\"",
    "unsupported_h": "Valikoimassamme ei ole {brand}-tuotteita (vielä)",
    "unsupported_p": "Jos olet jo varmistanut, että autosi tukee tehdasasenteista CarPlayta, tiimimme voi vielä tarkistaa, sopiiko jokin laitteistamme autoosi.",
    "unsupported_btn": "Kysy autostani →",
    "grouped_head": "{brand} {model} — valitse vuosimalliväli",
    "generations_head": "{brand} {model} — valitse vuosimalliväli",
    "no_match_h": "Ei osumia",
    "no_match_p": "Kokeile hakea pelkällä merkillä ja vuosimallilla. Jos et löydä autoasi, ota meihin yhteyttä.",
    "no_match_btn": "Kysy autostani →",
    "fit_badge": "Sopii autoosi {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox merkille {brand}",
    "fit_info_detected": "Tunnistettu automaattisesti <b>{system}</b>-järjestelmällesi.",
    "fit_info_default": "Langaton Apple CarPlay + Android Auto autonne alkuperäiseen infotainment-järjestelmään.",
    "fit_view_btn": "Näytä tuote →",
    "fit_change": "Eikö tämä ole autosi? Vaihda ajoneuvo",
    "yr_present": "esitellä"
  },
  "no": {
    "your_car": "bilen din",
    "fits_aria": "100 % passform",
    "fits_label": "Passer",
    "fit_msg": "Apple CarPlay &amp; Android Auto er <b>100% kompatibelt</b> med din <b class=\"co-fit-card__veh\">{label}</b>",
    "didyoumean": "Viser resultater for <b>{to}</b> — søkte etter \"{from}\"",
    "unsupported_h": "Vi fører ikke {brand} (ennå)",
    "unsupported_p": "Hvis du allerede har bekreftet at bilen har fabrikkmontert støtte for CarPlay, kan teamet vårt dobbeltsjekke om en av boksene våre fungerer.",
    "unsupported_btn": "Spør om bilen min →",
    "grouped_head": "{brand} {model} — velg et årsintervall",
    "generations_head": "{brand} {model} — velg årsintervallet ditt",
    "no_match_h": "Ingen treff",
    "no_match_p": "Prøv å bare oppgi bilmerke og årsmodell. Kontakt oss hvis du fortsatt ikke finner bilen din.",
    "no_match_btn": "Spør om bilen min →",
    "fit_badge": "Passer til din {brand} {model} ({yr})",
    "fit_h3": "CarPlayBox for {brand}",
    "fit_info_detected": "Registreres automatisk for <b>{system}</b>-systemet ditt.",
    "fit_info_default": "Trådløs Apple CarPlay + Android Auto for bilens fabrikkmonterte infotainmentsystem.",
    "fit_view_btn": "Vis produkt →",
    "fit_change": "Ikke bilen din? Bytt kjøretøy",
    "yr_present": "nåværende"
  }
};
  var I18N = LOCALE_STRINGS[window.CO_LOCALE] || LOCALE_STRINGS.en;
  function t(key, vars) {
    var s = I18N[key] || '';
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(vars[k]);
      });
    }
    return s;
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = fetch(INDEX_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { vehicles: [], brandAliases: {}, unsupported: {} }; });
    return indexPromise;
  }

  function norm(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_/\\\u2013\u2014]/g, ' ')  // hyphen, underscore, slashes, en-dash, em-dash
      .replace(/\s+/g, ' ').trim();
  }
  function tokens(s) { return norm(s).split(' ').filter(Boolean); }
  function extractYear(s) {
    var m = String(s).match(/\b(19[8-9]\d|20\d{2})\b/);
    return m ? +m[1] : null;
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n; if (!n) return m;
    var prev = new Array(n + 1), curr = new Array(n + 1);
    for (var j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      curr[0] = i;
      for (var jj = 1; jj <= n; jj++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(jj - 1) ? 0 : 1;
        curr[jj] = Math.min(prev[jj] + 1, curr[jj - 1] + 1, prev[jj - 1] + cost);
      }
      var tmp = prev; prev = curr; curr = tmp;
    }
    return prev[n];
  }

  function hasWord(haystack, needle) {
    if (!haystack || !needle) return false;
    if (haystack === needle) return true;
    if (haystack.indexOf(needle) === -1) return false;
    // Word-boundary check using normalised whitespace
    var idx = haystack.indexOf(needle);
    while (idx !== -1) {
      var before = idx === 0 ? ' ' : haystack[idx - 1];
      var after = idx + needle.length >= haystack.length ? ' ' : haystack[idx + needle.length];
      if (/\s/.test(before) && /\s/.test(after)) return true;
      idx = haystack.indexOf(needle, idx + 1);
    }
    return false;
  }

  function fuzzyTokenMatch(qTok, target) {
    if (!qTok || !target) return 0;
    if (target.indexOf(qTok) !== -1) return 1;
    if (qTok.length >= 3) {
      var parts = target.split(' ');
      for (var i = 0; i < parts.length; i++) {
        var d = levenshtein(qTok, parts[i]);
        if (d <= 1) return 0.9;
        if (qTok.length >= 5 && d <= 2) return 0.75;
      }
    }
    return 0;
  }

  function search(rawQ, idx) {
    var q = norm(rawQ);
    if (!q) return { kind: 'empty' };

    var year = extractYear(q);
    // Strip ALL years from the query (the user may type a range like
    // "2012–2020" — only the first year is used as a filter, the rest are
    // noise tokens that shouldn't influence scoring).
    var qNoYear = q.replace(/\b(19[8-9]\d|20\d{2})\b/g, '').trim();
    var qToks = tokens(qNoYear);
    var hasIntentTokens = qToks.length > 0;

    var brandAliases = idx.brandAliases || {};
    var unsupported = idx.unsupported || {};

    var resolvedBrand = null;
    // Multi-word aliases (e.g. "land rover", "mini cooper") — check on raw q
    Object.keys(brandAliases).forEach(function (k) {
      if (resolvedBrand) return;
      if (k.indexOf(' ') !== -1 && q.indexOf(k) !== -1) resolvedBrand = brandAliases[k];
    });
    // Single-word aliases — check on tokens
    if (!resolvedBrand) {
      for (var i = 0; i < qToks.length && !resolvedBrand; i++) {
        if (brandAliases[qToks[i]]) resolvedBrand = brandAliases[qToks[i]];
      }
    }

    // Unsupported?
    if (!resolvedBrand) {
      var uHit = null;
      Object.keys(unsupported).forEach(function (k) {
        if (uHit) return;
        if (k.indexOf(' ') !== -1) {
          if (q.indexOf(k) !== -1) uHit = unsupported[k];
        } else if (qToks.indexOf(k) !== -1) {
          uHit = unsupported[k];
        }
      });
      if (uHit) return { kind: 'unsupported', brand: uHit, query: rawQ };
    }

    // Build a set of all model alias tokens across the index for cheap lookup —
    // used to decide whether a typed token could legitimately *be* a model alias
    // (in which case we should NOT treat it as a typo of a brand name).
    if (!idx.__modelTokenSet) {
      var s = {};
      var vs = idx.vehicles || [];
      for (var iv = 0; iv < vs.length; iv++) {
        var ah = vs[iv].aliases || [];
        for (var ja = 0; ja < ah.length; ja++) {
          var an = norm(ah[ja]);
          if (an) s[an] = true;
        }
        var mn = norm(vs[iv].model);
        if (mn) s[mn] = true;
      }
      idx.__modelTokenSet = s;
    }

    var didYouMean = null;
    // Brand-typo correction. Only on tokens that don't look like model aliases.
    if (!resolvedBrand && qToks.length) {
      var first = qToks[0];
      if (first.length >= 3 && !idx.__modelTokenSet[first]) {
        var dymBest = null, dymD = Infinity;
        Object.keys(brandAliases).forEach(function (k) {
          if (k.length < 3 || k.indexOf(' ') !== -1) return;
          var d = levenshtein(first, k);
          var maxD = first.length >= 4 ? 2 : 1;
          if (d <= maxD && d < dymD) { dymD = d; dymBest = k; }
        });
        if (dymBest) {
          didYouMean = { from: first, to: brandAliases[dymBest] };
          resolvedBrand = brandAliases[dymBest];
        }
      }
    }

    // Score every vehicle
    var scored = [];
    var vehicles = idx.vehicles || [];
    var qNormFull = norm(qNoYear);
    for (var v = 0; v < vehicles.length; v++) {
      var veh = vehicles[v];
      var intentScore = 0;  // brand + model + token contributions only (no year)
      var aliasArr = veh.aliases || [];
      var aliases = aliasArr.join(' ');
      var modelRaw = veh.modelRaw || veh.model;
      var hay = norm([veh.brand, veh.model, modelRaw, aliases, veh.chassis || ''].join(' '));
      var modelNorm = norm(veh.model);

      if (resolvedBrand && veh.brand === resolvedBrand) intentScore += 4;

      if (modelNorm && hasWord(qNormFull, modelNorm)) {
        intentScore += 6;
      } else {
        for (var ai = 0; ai < aliasArr.length; ai++) {
          var aN = norm(aliasArr[ai]);
          if (aN && hasWord(qNormFull, aN)) { intentScore += 5; break; }
        }
      }

      for (var t = 0; t < qToks.length; t++) {
        var tok = qToks[t];
        if (tok.length < 2) continue;  // single-char tokens are noise
        if (resolvedBrand && brandAliases[tok] === resolvedBrand) continue;
        var m = fuzzyTokenMatch(tok, hay);
        if (m > 0) intentScore += m * (tok.length >= 3 ? 2 : 1);
      }

      // If the user typed brand/model intent but this vehicle didn't match
      // ANY of it, drop it — even if a year happens to be in range. Otherwise
      // "Volkswagen Golf 2012" would surface every car whose lifespan covers
      // 2012 (Jaguars, etc.).
      if (hasIntentTokens && intentScore === 0) continue;

      var score = intentScore;
      if (year && veh.y0 && veh.y1) {
        if (year >= veh.y0 && year <= veh.y1) score += 5;
        else score -= 1.5;
      }

      if (score > 1.5) scored.push({ v: veh, score: score });
    }
    // Primary: score desc. Tiebreak: y0 ascending (oldest generation first)
    // so multi-generation models read as a chronological timeline.
    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return (a.v.y0 || 0) - (b.v.y0 || 0);
    });

    if (scored.length === 0) {
      return { kind: 'no-match', query: rawQ, didYouMean: didYouMean };
    }

    // Group by model when brand resolved + no year + many matches
    if (resolvedBrand && !year && scored.length > 4) {
      var byModel = {};
      var ordered = [];
      for (var s = 0; s < scored.length; s++) {
        var vv = scored[s].v;
        if (vv.brand !== resolvedBrand) continue;
        var key = vv.model;
        if (!byModel[key]) { byModel[key] = []; ordered.push(key); }
        byModel[key].push(vv);
      }
      var groups = ordered.map(function (k) { return { model: k, vehicles: byModel[k] }; });
      if (groups.length > 1) {
        return { kind: 'grouped', brand: resolvedBrand, groups: groups, didYouMean: didYouMean };
      }
    }

    // Group by year-range when single brand+model with multiple generations
    if (resolvedBrand && !year) {
      var topModel = scored[0].v.model;
      var sameModel = scored.filter(function (x) { return x.v.brand === resolvedBrand && x.v.model === topModel; });
      if (sameModel.length > 1) {
        var seen = {};
        var generations = [];
        sameModel.forEach(function (x) {
          var key = x.v.y0 + '-' + x.v.y1;
          if (!seen[key]) { seen[key] = true; generations.push(x.v); }
        });
        if (generations.length > 1) {
          return { kind: 'generations', brand: resolvedBrand, model: topModel, vehicles: generations, didYouMean: didYouMean };
        }
      }
    }

    return { kind: 'matches', items: scored.slice(0, 8).map(function (x) { return x.v; }), didYouMean: didYouMean };
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function brandInitials(brand) {
    return brand.split(/[\s\-]/).filter(Boolean).map(function (p) { return p[0]; }).join('').slice(0, 2).toUpperCase();
  }

  function yearLabel(v) {
    if (v.y1 >= 2025) return v.y0 + '–' + I18N.yr_present;
    return v.y0 + '–' + v.y1;
  }

  function renderSug(v, opts) {
    opts = opts || {};
    var year = yearLabel(v);
    var chassis = v.chassis ? '<span class="cof__sug-chassis">' + escapeHTML(v.chassis) + '</span>' : '';
    var classes = 'cof__sug';
    var fitTag = '';
    if (opts.confirmedFit) {
      classes += ' is-fit';
      fitTag = '<span class="cof__sug-fittag" aria-label="' + I18N.fits_aria + '">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
        ' ' + I18N.fits_label +
        '</span>';
    }
    return (
      '<button class="' + classes + '" role="option" data-id="' + escapeHTML(v.id) + '">' +
      '<span class="cof__sug-logo">' + escapeHTML(brandInitials(v.brand)) + '</span>' +
      '<span class="cof__sug-body">' +
      '<span class="cof__sug-title">' + escapeHTML(v.brand) + ' ' + escapeHTML(v.modelRaw || v.model) + '</span>' +
      '<span class="cof__sug-meta">' +
      '<span class="cof__sug-year">' + year + '</span>' +
      chassis +
      '</span>' +
      '</span>' +
      fitTag +
      '<svg class="cof__sug-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
      '</button>'
    );
  }

  function setGarage(v) {
    var label = (v.y0 === v.y1 ? v.y0 : v.y0 + '–' + (v.y1 >= 2025 ? I18N.yr_present : v.y1)) + ' ' + v.brand + ' ' + (v.modelRaw || v.model);
    try { localStorage.setItem('co_garage', JSON.stringify({ id: v.id, label: label, productHandle: v.productHandle, variantId: v.variantId })); } catch (e) {}
    document.cookie = 'co_garage=' + encodeURIComponent(v.id) + '; path=/; max-age=' + (60 * 60 * 24 * 90) + '; SameSite=Lax';
    renderGarageChips();
  }

  function clearGarage() {
    try { localStorage.removeItem('co_garage'); } catch (e) {}
    document.cookie = 'co_garage=; path=/; max-age=0; SameSite=Lax';
    renderGarageChips();
  }

  function getGarage() {
    try {
      var s = localStorage.getItem('co_garage');
      if (s) return JSON.parse(s);
    } catch (e) {}
    return null;
  }

  function renderGarageChips() {
    var data = getGarage();
    document.querySelectorAll('[data-co-garage-chip]').forEach(function (el) {
      if (data) {
        el.classList.add('is-on');
        var label = el.querySelector('[data-co-garage-label]');
        if (label) label.textContent = data.label;
        var go = el.querySelector('[data-co-garage-go]');
        if (go && data.productHandle) {
          go.href = withLocale('/products/' + data.productHandle) + (data.variantId ? '?variant=' + data.variantId : '');
        }
      } else {
        el.classList.remove('is-on');
      }
    });
  }

  function navigateToVariant(v, openInNew) {
    // Stash the pending-fit signal in sessionStorage BEFORE navigating —
    // Shopify's variant picker rewrites the URL on load and strips unknown
    // query params, so we can't rely on ?fit=1 surviving the trip.
    try {
      sessionStorage.setItem('co_pending_fit', JSON.stringify({
        id: v.id,
        productHandle: v.productHandle,
        variantId: v.variantId || null,
        ts: Date.now()
      }));
    } catch (e) {}
    var qs = [];
    // For deduped/grouped vehicles (variantId === null) we don't preselect a
    // variant — the customer picks the head unit on the product page.
    if (v.variantId) qs.push('variant=' + v.variantId);
    qs.push('fit=1');
    qs.push('vid=' + encodeURIComponent(v.id));
    var url = withLocale('/products/' + v.productHandle) + '?' + qs.join('&');
    if (openInNew) window.open(url, '_blank');
    else window.location.href = url;
  }

  // Try to find a vehicle in the index by id (set by ?vid= or stored garage).
  function findVehicleById(idx, id) {
    if (!id || !idx || !idx.vehicles) return null;
    for (var i = 0; i < idx.vehicles.length; i++) {
      if (idx.vehicles[i].id === id) return idx.vehicles[i];
    }
    return null;
  }

  function getQueryParam(name) {
    if (!window.location.search) return null;
    var params = window.location.search.replace(/^\?/, '').split('&');
    for (var i = 0; i < params.length; i++) {
      var kv = params[i].split('=');
      if (decodeURIComponent(kv[0]) === name) return decodeURIComponent(kv[1] || '');
    }
    return null;
  }

  // Confetti: 360° burst from the centre of `host`. Each piece is launched in
  // a random direction with a random initial speed; gravity then pulls them
  // down via a CSS variable in the keyframe. ~50 pieces, no dependency.
  function fireConfetti(host) {
    if (!host) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    // Brand-driven palette: blue lead, plus festive accent colours that aren't
    // used as static UI elements anywhere on the site.
    var colors = ['#1556FF', '#0A8F4E', '#FF4D6D', '#7C3AED', '#22D3EE', '#0F44D8', '#FF7A1A'];
    var layer = document.createElement('div');
    layer.className = 'co-fit-confetti';
    layer.setAttribute('aria-hidden', 'true');
    var pieces = 56;
    for (var i = 0; i < pieces; i++) {
      var p = document.createElement('span');
      p.className = 'co-fit-confetti__p';
      // Pick a random angle in the upper hemisphere mostly (so pieces shoot
      // up and outward, then fall) but allow some sideways too.
      var angle = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.4; // -126° to -54° from horizontal, i.e. up-ish
      var velocity = 80 + Math.random() * 220;
      var dx = Math.round(Math.cos(angle) * velocity);
      var dy = Math.round(Math.sin(angle) * velocity);   // mostly negative (upward)
      var gravity = 280 + Math.random() * 160;            // px of "fall" added at the end
      var delay = Math.round(Math.random() * 120);
      var dur = (1100 + Math.random() * 700).toFixed(0);
      var rot = Math.round(Math.random() * 1080 - 540);
      var color = colors[i % colors.length];
      var size = Math.round(6 + Math.random() * 6);
      // Mix two shapes so it feels like real confetti, not pixels
      var shape = i % 3 === 0 ? '50%' : '2px';
      p.style.cssText =
        'background:' + color + ';' +
        'width:' + size + 'px;height:' + (size + 4) + 'px;' +
        'border-radius:' + shape + ';' +
        'animation-delay:' + delay + 'ms;' +
        'animation-duration:' + dur + 'ms;' +
        '--cof-dx:' + dx + 'px;' +
        '--cof-dy:' + dy + 'px;' +
        '--cof-gravity:' + Math.round(gravity) + 'px;' +
        '--cof-rot:' + rot + 'deg;';
      layer.appendChild(p);
    }
    host.appendChild(layer);
    setTimeout(function () { if (layer.parentElement) layer.parentElement.removeChild(layer); }, 2400);
  }

  // Find the best mount point on the product page so the card sits ABOVE the
  // gallery image. The Kalles theme this site uses puts the layout inside
  // .t4s-main-product__content; we insert as that container's first child so
  // the card spans the full content width on desktop and stacks above on
  // mobile. Falls back through ever-broader containers, finally <main>.
  function findFitMount() {
    var candidates = [
      '.t4s-main-product__content',
      '[data-product-featured]',
      '.t4s-row__product',
      '.t4s-section-main-product',
      '.t4s-product__media-wrapper',
      '.t4s-product__media',
      '.product__media',
      '[data-product-media]',
      'main',
      '[role="main"]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return document.body;
  }

  function readPendingFit() {
    var pending = null;
    try {
      var raw = sessionStorage.getItem('co_pending_fit');
      if (raw) {
        pending = JSON.parse(raw);
        // Expire after 10 minutes — covers slow phones / new tabs without
        // leaving a stale celebration on revisits.
        if (!pending || Date.now() - (pending.ts || 0) > 10 * 60 * 1000) pending = null;
      }
    } catch (e) {}
    return pending;
  }

  function clearPendingFit() {
    try { sessionStorage.removeItem('co_pending_fit'); } catch (e) {}
  }

  function showFitBanner(idx) {
    var pending = readPendingFit();
    var fromUrlFit = getQueryParam('fit') === '1';
    if (!pending && !fromUrlFit) return;
    // If a card is already on the page (e.g. theme section reload re-fired
    // init), don't insert a duplicate.
    if (document.querySelector('.co-fit-card')) return;
    var vid = (pending && pending.id) || getQueryParam('vid');
    var veh = findVehicleById(idx, vid);
    // Trim to brand + canonical model only — no year, no chassis sub-codes
    // ("3 Series" not "3 Series / M3"). Keep it clean for the celebration.
    var label = veh ? veh.brand + ' ' + veh.model : I18N.your_car;

    var mount = findFitMount();
    if (!mount) return;
    var existing = document.querySelector('.co-fit-card');
    if (existing) existing.parentElement.removeChild(existing);

    var card = document.createElement('div');
    card.className = 'co-fit-card';
    card.innerHTML =
      '<div class="co-fit-card__row">' +
      '<span class="co-fit-card__check" aria-hidden="true">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
      '</span>' +
      '<span class="co-fit-card__body">' +
      '<span class="co-fit-card__msg">' + t('fit_msg', { label: escapeHTML(label) }) + '</span>' +
      '</span>' +
      '</div>' +
      '<div class="co-fit-card__confetti-host" aria-hidden="true"></div>';
    mount.insertBefore(card, mount.firstChild);

    // Trigger confetti after a short delay so the user perceives the page
    // first and the celebration feels intentional rather than chaotic.
    setTimeout(function () {
      // Re-query in case the host node was reattached by the theme between
      // initial render and now.
      var host = card.querySelector('.co-fit-card__confetti-host');
      fireConfetti(host || card);
    }, 700);

    // Clear the pending-fit flag a beat after we've shown the card so that:
    //   (a) any theme section-reload that fires within a few seconds still
    //       finds the flag and re-attaches the card (idempotent via the
    //       early "already on page" check); and
    //   (b) a manual page refresh later shows a clean product page without
    //       re-celebrating an old selection.
    setTimeout(clearPendingFit, 2500);
  }

  function priceFmt(p) {
    if (!p) return '';
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return '€' + n.toFixed(0);
  }

  function initFinder(root, idx) {
    var input = root.querySelector('[data-cof-input]');
    var results = root.querySelector('[data-cof-results]');
    // fit-card area is rendered as a sibling of the finder, not a descendant —
    // look in the next siblings, then up to one ancestor for a match.
    var fitArea = root.querySelector('[data-cof-fit]');
    if (!fitArea) {
      var sib = root.nextElementSibling;
      while (sib && !fitArea) {
        if (sib.matches && sib.matches('[data-cof-fit]')) fitArea = sib;
        else if (sib.querySelector) fitArea = sib.querySelector('[data-cof-fit]');
        sib = sib.nextElementSibling;
      }
    }
    if (!fitArea && root.parentElement) {
      fitArea = root.parentElement.querySelector('[data-cof-fit]');
    }
    var clearBtn = root.querySelector('[data-cof-clear]');
    var submitBtn = root.querySelector('[data-cof-submit]');
    var hints = root.querySelector('[data-cof-hints]');
    var inputWrap = root.querySelector('[data-cof-input-wrap]');
    var brandSel = root.querySelector('[data-cof-brand]');
    var modelSel = root.querySelector('[data-cof-model]');
    if (!input || !results) return;

    // Populate the brand select once. Brands are pulled from the canonical
    // values in idx.brandAliases, deduplicated and alphabetically sorted.
    if (brandSel && !brandSel.__cofPopulated) {
      brandSel.__cofPopulated = true;
      var brandSet = {};
      Object.keys(idx.brandAliases || {}).forEach(function (k) { brandSet[idx.brandAliases[k]] = true; });
      Object.keys(brandSet).sort().forEach(function (b) {
        var o = document.createElement('option');
        o.value = b;
        o.textContent = b;
        brandSel.appendChild(o);
      });
    }

    function modelsForBrand(brand) {
      if (!brand || !idx.vehicles) return [];
      var seen = {};
      var out = [];
      for (var i = 0; i < idx.vehicles.length; i++) {
        var v = idx.vehicles[i];
        if (v.brand !== brand) continue;
        if (seen[v.model]) continue;
        seen[v.model] = true;
        out.push(v.model);
      }
      out.sort(function (a, b) { return a.localeCompare(b); });
      return out;
    }

    function populateModels(brand) {
      if (!modelSel) return;
      // Wipe everything except the placeholder
      while (modelSel.options.length > 1) modelSel.remove(1);
      var models = modelsForBrand(brand);
      models.forEach(function (m) {
        var o = document.createElement('option');
        o.value = m;
        o.textContent = m;
        modelSel.appendChild(o);
      });
      modelSel.disabled = models.length === 0;
      modelSel.value = '';
    }

    var debounceT;
    var activeIdx = -1;
    var lastResult = null;

    function open() { root.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function close() { root.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); activeIdx = -1; }

    function render() {
      var q = input.value.trim();
      if (inputWrap) inputWrap.classList.toggle('has-value', q.length > 0);
      if (clearBtn) clearBtn.style.display = q.length ? 'flex' : 'none';
      if (q.length === 0) { close(); results.innerHTML = ''; return; }

      var r = search(q, idx);
      lastResult = r;
      open();

      // Year-confirmed fit: row gets the "is-fit" callout only when ALL of:
      //   (1) the user typed a 4-digit year,
      //   (2) the year falls inside the row's [y0, y1] range, AND
      //   (3) the user explicitly mentioned this row's model (name or alias)
      // — otherwise sibling models (1 Series for "3 series 2016") would also
      // light up just because their year span happens to include 2016.
      var qNorm = norm(q);
      var qYear = extractYear(qNorm);
      var fitOf = function (v) {
        if (!qYear || !v.y0 || !v.y1) return false;
        if (qYear < v.y0 || qYear > v.y1) return false;
        var modelNorm = norm(v.model);
        if (modelNorm && hasWord(qNorm, modelNorm)) return true;
        var aliases = v.aliases || [];
        for (var i = 0; i < aliases.length; i++) {
          if (hasWord(qNorm, norm(aliases[i]))) return true;
        }
        return false;
      };

      var html = '';
      if (r.didYouMean) {
        html += '<div class="cof__didyoumean">' + t('didyoumean', { to: escapeHTML(r.didYouMean.to), from: escapeHTML(r.didYouMean.from) }) + '</div>';
      }

      if (r.kind === 'unsupported') {
        html += '<div class="cof__empty"><h4>' + t('unsupported_h', { brand: escapeHTML(r.brand) }) + '</h4>' +
          '<p>' + I18N.unsupported_p + '</p>' +
          '<a class="cof__btn" href="' + withLocale('/pages/contact') + '?vehicle=' + encodeURIComponent(q) + '">' + I18N.unsupported_btn + '</a></div>';
      } else if (r.kind === 'grouped') {
        for (var g = 0; g < r.groups.length; g++) {
          var grp = r.groups[g];
          html += '<div class="cof__sec"><div class="cof__sec-head">' + t('grouped_head', { brand: escapeHTML(r.brand), model: escapeHTML(grp.model) }) + '</div>';
          for (var i = 0; i < grp.vehicles.length; i++) html += renderSug(grp.vehicles[i], { confirmedFit: fitOf(grp.vehicles[i]) });
          html += '</div>';
        }
      } else if (r.kind === 'generations') {
        html += '<div class="cof__sec"><div class="cof__sec-head">' + t('generations_head', { brand: escapeHTML(r.brand), model: escapeHTML(r.model) }) + '</div>';
        for (var j = 0; j < r.vehicles.length; j++) html += renderSug(r.vehicles[j], { confirmedFit: fitOf(r.vehicles[j]) });
        html += '</div>';
      } else if (r.kind === 'matches') {
        html += '<div class="cof__sec">';
        for (var m = 0; m < r.items.length; m++) html += renderSug(r.items[m], { confirmedFit: fitOf(r.items[m]) });
        html += '</div>';
      } else if (r.kind === 'no-match') {
        html += '<div class="cof__empty"><h4>' + I18N.no_match_h + '</h4>' +
          '<p>' + I18N.no_match_p + '</p>' +
          '<a class="cof__btn" href="' + withLocale('/pages/contact') + '?vehicle=' + encodeURIComponent(q) + '">' + I18N.no_match_btn + '</a></div>';
      }
      results.innerHTML = html;
      bindResultClicks();
    }

    function bindResultClicks() {
      results.querySelectorAll('.cof__sug').forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-id');
          var v = idx.vehicles.find(function (x) { return x.id === id; });
          if (v) selectVehicle(v);
        });
      });
    }

    function selectVehicle(v) {
      close();
      input.value = v.brand + ' ' + (v.modelRaw || v.model) + ' ' + (v.y1 >= 2025 ? v.y0 + '+' : v.y0 + '–' + v.y1);
      if (inputWrap) inputWrap.classList.add('has-value');
      setGarage(v);
      // Always redirect to the product page so the customer lands directly
      // where they can buy. The product page detects the ?fit=1 param and
      // shows a "100% fit" banner + confetti.
      navigateToVariant(v);
    }

    function renderFitCard(v) {
      if (!fitArea) return;
      var yr = yearLabel(v);
      var price = priceFmt(v.price);
      var info = v.infoDisplay
        ? '<p>' + t('fit_info_detected', { system: escapeHTML(v.infoDisplay) }) + '</p>'
        : '<p>' + I18N.fit_info_default + '</p>';
      fitArea.innerHTML =
        '<div class="cof__fit is-fits">' +
        '<div class="cof__fit-body">' +
        '<span class="cof__fit-badge">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
        ' ' + t('fit_badge', { brand: escapeHTML(v.brand), model: escapeHTML(v.modelRaw || v.model), yr: yr }) + '</span>' +
        '<h3>' + t('fit_h3', { brand: escapeHTML(v.brand) }) + '</h3>' +
        info +
        (price ? '<div class="cof__fit-price">' + price + '</div>' : '') +
        '<div class="cof__fit-actions">' +
        '<a class="cof__btn cof__btn-primary" href="' + withLocale('/products/' + escapeHTML(v.productHandle)) + (v.variantId ? '?variant=' + v.variantId : '') + '">' + I18N.fit_view_btn + '</a>' +
        '<a class="cof__btn cof__btn-link" href="#" data-cof-change>' + I18N.fit_change + '</a>' +
        '</div></div></div>';
      var changeLink = fitArea.querySelector('[data-cof-change]');
      if (changeLink) changeLink.addEventListener('click', function (e) { e.preventDefault(); clearAll(); input.focus(); });
    }

    function clearAll() {
      input.value = '';
      if (inputWrap) inputWrap.classList.remove('has-value');
      close();
      results.innerHTML = '';
      if (fitArea) fitArea.innerHTML = '';
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceT);
      debounceT = setTimeout(render, 80);
    });
    input.addEventListener('focus', function () { if (input.value.trim()) open(); });
    input.addEventListener('keydown', function (e) {
      var items = results.querySelectorAll('.cof__sug');
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); items.forEach(function (x, i) { x.classList.toggle('is-active', i === activeIdx); }); if (items[activeIdx]) items[activeIdx].scrollIntoView({ block: 'nearest' }); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); items.forEach(function (x, i) { x.classList.toggle('is-active', i === activeIdx); }); if (items[activeIdx]) items[activeIdx].scrollIntoView({ block: 'nearest' }); }
       else if (e.key === 'Enter') { if (activeIdx >= 0 && items[activeIdx]) { e.preventDefault(); items[activeIdx].click(); } }
       else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { clearAll(); input.focus(); });

    // Brand dropdown change → populate models. Doesn't touch the text input,
    // so a user who's mid-typing isn't disturbed.
    if (brandSel) {
      brandSel.addEventListener('change', function () {
        populateModels(brandSel.value);
      });
    }

    // Find the best vehicle for a (brand, model) pair: prefer the most recent
    // year-range so customers buying for a current car land on the right
    // chassis without disambiguating.
    function pickBestForDropdowns(brand, model) {
      if (!brand) return null;
      var candidates = (idx.vehicles || []).filter(function (v) {
        if (v.brand !== brand) return false;
        if (model && v.model !== model) return false;
        return true;
      });
      if (!candidates.length) return null;
      candidates.sort(function (a, b) { return (b.y1 || 0) - (a.y1 || 0); });
      return candidates[0];
    }

    function submit() {
      // 1) Free-text wins when present — pick the active or first suggestion.
      var text = input.value.trim();
      if (text.length) {
        var items = results.querySelectorAll('.cof__sug');
        if (items.length) {
          (items[Math.max(activeIdx, 0)] || items[0]).click();
          return;
        }
        input.focus();
        render();
        return;
      }
      // 2) No text — fall back to whatever the dropdowns specify.
      var brand = brandSel ? brandSel.value : '';
      var model = modelSel ? modelSel.value : '';
      if (brand && model) {
        var v = pickBestForDropdowns(brand, model);
        if (v) { selectVehicle(v); return; }
      }
      if (brand) {
        // Show the brand's models grouped — same UX as typing the brand name.
        input.value = brand;
        render();
        return;
      }
      // 3) Nothing — focus the input.
      input.focus();
    }

    if (submitBtn) submitBtn.addEventListener('click', submit);
    // Pressing Enter inside the model select also submits.
    if (modelSel) modelSel.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    if (hints) {
      hints.querySelectorAll('[data-cof-chip]').forEach(function (c) {
        c.addEventListener('click', function () {
          input.value = c.getAttribute('data-cof-chip');
          input.focus();
          render();
        });
      });
    }
  }

  function init() {
    loadIndex().then(function (idx) {
      document.querySelectorAll('[data-co-finder]').forEach(function (root) {
        if (root.__cofInited) return;
        root.__cofInited = true;
        initFinder(root, idx);
      });
      // Garage chips can render without index
      renderGarageChips();
      // Garage clear handlers
      document.querySelectorAll('[data-co-garage-clear]').forEach(function (b) {
        if (b.__cofGCBound) return;
        b.__cofGCBound = true;
        b.addEventListener('click', function (e) { e.preventDefault(); clearGarage(); });
      });
      // 100%-fit banner when arriving from a search redirect
      if (!window.__cofBannerShown) {
        window.__cofBannerShown = true;
        showFitBanner(idx);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections load dynamically (Shopify section reload)
  document.addEventListener('shopify:section:load', init);
})();
